/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type CreditCardIssuer = 0 | 3 | 4 | 5 | 6 | 7;

export const CreditCardIssuer = {
    NUMBER_0: 0 as CreditCardIssuer,
    NUMBER_3: 3 as CreditCardIssuer,
    NUMBER_4: 4 as CreditCardIssuer,
    NUMBER_5: 5 as CreditCardIssuer,
    NUMBER_6: 6 as CreditCardIssuer,
    NUMBER_7: 7 as CreditCardIssuer
}